module.exports = __webpack_public_path__ + "img/tester1.53db6aa1.png";